module.exports = __webpack_public_path__ + "static/media/DSCF31691.e011b4ff.png";